module.exports = __webpack_public_path__ + "img/chooseup.5d3da046.svg";